import { useParams } from 'react-router-dom';
import LibModal from '../../../../features/LibModal/LibModal';
import NotFound from '../../../../features/NotFound/NotFoundPage';
import PageTables from './Components/PageTables';
import ServiceInfo from './Components/ServiceInfo';
import AddPackageModal from './Modals/AddPackageModal';
import AddPackagePriceModal from './Modals/AddPackagePriceModal';
import EditServiceModal from './Modals/EditServiceModal';
import ProductDetailsProvider, { useServiceDt } from './ServiceDetailsProvider';

function PageContent() {
    const {
        openModal,
        closeModal,
        modalType,
        modalData,
        serviceInfo,
        handleReload,
        packageInfo,
        isSelected,
        isClicked
    } = useServiceDt();

    if (serviceInfo && Object.keys(serviceInfo).length === 0) {
        return (
            <div className="inner_page_cont">
                <NotFound
                    title="No Service Found!"
                    btnTitle="Back to list"
                    path="/settings/services"
                    className="h-full"
                />
            </div>
        );
    }
    return (
        <div className="h-full">
            <ServiceInfo />
            <PageTables
                openModal={openModal}
                serviceInfo={serviceInfo}
                isSelected={isSelected}
                isClicked={isClicked}
                packageInfo={packageInfo}
            />

            {/* modals */}
            {modalType === 'editService' && (
                <LibModal title="Edit Service" setOpen={closeModal}>
                    <EditServiceModal
                        data={modalData}
                        handleReload={handleReload}
                        closeModal={closeModal}
                    />
                </LibModal>
            )}
            {modalType === 'addPackage' && (
                <LibModal title="Add Package" setOpen={closeModal}>
                    <AddPackageModal
                        closeModal={closeModal}
                        handleReload={handleReload}
                        data={serviceInfo}
                    />
                </LibModal>
            )}
            {modalType === 'addPrice' && (
                <LibModal title="Add Package Price" setOpen={closeModal}>
                    <AddPackagePriceModal
                        closeModal={closeModal}
                        handleReload={handleReload}
                        packageInfo={packageInfo}
                        serviceInfo={serviceInfo}
                    />
                </LibModal>
            )}
        </div>
    );
}

function ServiceDetailsPage() {
    const { serviceId } = useParams();
    return (
        <ProductDetailsProvider serviceId={serviceId}>
            <div className="products-setting inner_page_cont">
                <PageContent />
            </div>
        </ProductDetailsProvider>
    );
}

export default ServiceDetailsPage;
